import React, { useState } from 'react';

// 더미 데이터
const dummySalesData = {
    today: {
        sales: 5,
        revenue: 495000,
        orders: 5
    },
    week: {
        sales: 32,
        revenue: 3168000,
        orders: 32
    },
    month: {
        sales: 145,
        revenue: 14355000,
        orders: 145
    },
    recentOrders: [
        {
            id: 1,
            orderNumber: 'ORD-2025-001',
            productName: '연기 기초 마스터 클래스',
            customerName: '김학생',
            amount: 99000,
            date: '2025-01-15 14:30',
            status: '완료'
        },
        {
            id: 2,
            orderNumber: 'ORD-2025-002',
            productName: 'K-pop 댄스 비디오 강의',
            customerName: '박연습',
            amount: 79000,
            date: '2025-01-15 13:15',
            status: '완료'
        },
        {
            id: 3,
            orderNumber: 'ORD-2025-003',
            productName: '보컬 트레이닝 패키지',
            customerName: '이성장',
            amount: 149000,
            date: '2025-01-15 11:45',
            status: '완료'
        },
        {
            id: 4,
            orderNumber: 'ORD-2025-004',
            productName: '연기 기초 마스터 클래스',
            customerName: '최지망',
            amount: 99000,
            date: '2025-01-14 18:20',
            status: '완료'
        },
        {
            id: 5,
            orderNumber: 'ORD-2025-005',
            productName: 'K-pop 댄스 비디오 강의',
            customerName: '정댄스',
            amount: 79000,
            date: '2025-01-14 16:10',
            status: '완료'
        }
    ],
    topProducts: [
        {
            id: 1,
            name: '연기 기초 마스터 클래스',
            sales: 125,
            revenue: 12375000
        },
        {
            id: 2,
            name: 'K-pop 댄스 비디오 강의',
            sales: 89,
            revenue: 7031000
        },
        {
            id: 3,
            name: '보컬 트레이닝 패키지',
            sales: 45,
            revenue: 6705000
        }
    ]
};

const KoachSalesStatus = () => {
    const [salesData] = useState(dummySalesData);
    const [period, setPeriod] = useState('month');

    const getPeriodData = () => {
        switch(period) {
            case 'today': return salesData.today;
            case 'week': return salesData.week;
            case 'month': return salesData.month;
            default: return salesData.month;
        }
    };

    const periodData = getPeriodData();

    return (
        <div className="min-h-screen bg-gray-50 pt-20 pb-4 px-4">
            <div className="max-w-6xl mx-auto">
                <h1 className="text-2xl font-bold text-gray-900 mb-6">판매 현황</h1>

                {/* 기간 선택 */}
                <div className="flex gap-2 mb-6">
                    <button
                        onClick={() => setPeriod('today')}
                        className={`px-4 py-2 rounded-lg transition-colors ${
                            period === 'today' 
                                ? 'bg-[#CF3688] text-white' 
                                : 'bg-white text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                        오늘
                    </button>
                    <button
                        onClick={() => setPeriod('week')}
                        className={`px-4 py-2 rounded-lg transition-colors ${
                            period === 'week' 
                                ? 'bg-[#CF3688] text-white' 
                                : 'bg-white text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                        이번 주
                    </button>
                    <button
                        onClick={() => setPeriod('month')}
                        className={`px-4 py-2 rounded-lg transition-colors ${
                            period === 'month' 
                                ? 'bg-[#CF3688] text-white' 
                                : 'bg-white text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                        이번 달
                    </button>
                </div>

                {/* 통계 카드 */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                    <div className="bg-white rounded-lg shadow-sm p-6">
                        <p className="text-sm text-gray-600 mb-1">총 매출</p>
                        <p className="text-2xl font-bold text-[#CF3688]">
                            {periodData.revenue.toLocaleString()}원
                        </p>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm p-6">
                        <p className="text-sm text-gray-600 mb-1">총 판매량</p>
                        <p className="text-2xl font-bold text-gray-900">
                            {periodData.sales.toLocaleString()}개
                        </p>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm p-6">
                        <p className="text-sm text-gray-600 mb-1">주문 건수</p>
                        <p className="text-2xl font-bold text-gray-900">
                            {periodData.orders.toLocaleString()}건
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* 최근 주문 */}
                    <div className="bg-white rounded-lg shadow-sm p-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-4">최근 주문</h2>
                        <div className="space-y-4">
                            {salesData.recentOrders.map((order) => (
                                <div key={order.id} className="border-b border-gray-200 pb-4 last:border-0">
                                    <div className="flex justify-between items-start mb-2">
                                        <div>
                                            <p className="text-sm font-medium text-gray-900">{order.productName}</p>
                                            <p className="text-xs text-gray-500">{order.orderNumber}</p>
                                        </div>
                                        <span className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs">
                                            {order.status}
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <span className="text-sm text-gray-600">{order.customerName}</span>
                                        <div className="text-right">
                                            <p className="text-sm font-semibold text-gray-900">
                                                {order.amount.toLocaleString()}원
                                            </p>
                                            <p className="text-xs text-gray-500">{order.date}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* 인기 상품 */}
                    <div className="bg-white rounded-lg shadow-sm p-6">
                        <h2 className="text-lg font-semibold text-gray-900 mb-4">인기 상품</h2>
                        <div className="space-y-4">
                            {salesData.topProducts.map((product, index) => (
                                <div key={product.id} className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <div className="w-8 h-8 rounded-full bg-[#CF3688] text-white flex items-center justify-center font-bold mr-3">
                                            {index + 1}
                                        </div>
                                        <div>
                                            <p className="text-sm font-medium text-gray-900">{product.name}</p>
                                            <p className="text-xs text-gray-500">
                                                판매량: {product.sales}개
                                            </p>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-sm font-semibold text-gray-900">
                                            {product.revenue.toLocaleString()}원
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KoachSalesStatus;

